// Dependencies

import { IonProgressBar } from '@ionic/react';

// Components and functions

import { useAppSelector } from '../../store/hooks';

// Styles

import { WrapperDiv } from './FormSpinner.styles';

// Props

interface IComponentProps { }

export const FormSpinner: React.FC<IComponentProps> = () => {
  const { isLoadingCount } = useAppSelector(state => state.app);

  return (
    <WrapperDiv>
      <>{isLoadingCount > 0 ? <IonProgressBar type="indeterminate" color="secondary"></IonProgressBar> : <></>}</>
    </WrapperDiv>
  );
};
